import styled from 'styled-components'

export const ArticlesWrapperContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (min-width: 320px) and (max-width: 767px) {
    justify-content: center;
  }
`
